// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1SVY-","label":"Completed_label__2NyWO"};